interface Props {
  children?: string | React.ReactNode
  iconComponent?: React.ReactNode
  onClick?: () => void
}

export const MenuItem = ({ children, iconComponent, onClick }: Props) => {
  return (
    <button
      type="button"
      className="flex items-center gap-2 p-1.5 text-sm font-medium text-content-subdued text-left bg-transparent w-full rounded hover:bg-background-hovered hover:text-content-hovered"
      onClick={onClick}
    >
      {iconComponent}
      {children}
    </button>
  )
}
